<template>
  <div>
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-card>
      <v-card-title>
        <h3>Communication Group</h3>
      </v-card-title>
      <v-card-text>
        <v-row justify="center">
          <v-col cols="12" sm="6" md="6">
            <v-text-field label="Group Name" placeholder="Music-Batch-1-2020" persistent-hint hint="Enter Group Name"
              v-model.trim="group_name" dense></v-text-field>
          </v-col>
        </v-row>
        <v-row justify="center">
          <v-col cols="12" sm="6" md="6">
            <v-textarea v-model.trim="group_description" label="Group Description" value
              placeholder="This group is for...." persistent-hint hint="Enter Group Description"></v-textarea>
          </v-col>
        </v-row>
        <v-row justify="center">
          <v-col cols="12" sm="6" md="6">
            <v-btn @click="createGroup" :loading="create_btn_load" dense color="info">Create</v-btn>
          </v-col>
        </v-row>
        <v-row v-if="group_code">
          <span>
            Group Code for
            <b>{{group_name}}</b> is
            <b>
              <i>{{group_code}}</i>
            </b>
          </span>
        </v-row>
      </v-card-text>
    </v-card>
    <v-card v-if="commn_grp_list">
      <v-card-title>
        Communication Groups
        <v-spacer></v-spacer>
        <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
      </v-card-title>
      <v-card-text>
        <v-data-table :headers="commn_grp_list_headers" :items="commn_grp_list" :search="search" multi-sort
          class="elevation-1">
          <template v-slot:item.grp_members="{ item }">
            <v-btn link :loading="members_list_load" @click="getMembers(item)">{{item.grp_members}}</v-btn>
          </template>
          <template v-slot:item.grp_isactive="{ item }">
            <v-switch v-model="item.grp_isactive" :loading="toggle_btn_load" @change="toggleGroup(item)"></v-switch>
          </template>
          <template v-slot:item.action="{ item }">
            <v-icon small class="mr-2" @click="editGroup(item)">mdi-pencil</v-icon>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
    <v-dialog v-model="dialog" width="500">
      <v-card v-if="edit_commn_grp">
        <v-card-title class="headline grey lighten-2" primary-title>Edit Communication Group</v-card-title>

        <v-card-text>
          <!-- {{edit_commn_grp}} -->
          <v-row justify="center">
            <v-col cols="12" sm="8" md="8">
              <v-text-field label="Group Name" persistent-hint hint="Enter Group Name"
                v-model.trim="edit_commn_grp.grp_name" dense></v-text-field>
            </v-col>
          </v-row>
          <v-row justify="center">
            <v-col cols="12" sm="8" md="8">
              <v-textarea v-model.trim="edit_commn_grp.grp_description" label="Group Description" persistent-hint
                hint="Enter Group Description"></v-textarea>
            </v-col>
          </v-row>
          <v-row justify="center">
            <v-col cols="12" sm="2" md="2">
              <v-switch :label="`${edit_commn_grp.grp_isactive?'Deactivate':'Activate'}`"
                v-model="edit_commn_grp.grp_isactive"></v-switch>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text :loading="edit_btn_load" @click="saveEditGroup">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_member" style="margin-top: 10%" fullscreen hide-overlay
      transition="dialog-top-transition">
      <v-card class="mx-auto" v-if="member_grp_data">
        <v-toolbar dark color="primary">
          <v-toolbar-title>Group Members</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark text @click="dialog_member = false"><v-icon>mdi-close</v-icon>Close</v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <br />
        <v-card-text>
          <center>
            <v-chip class="ma-2">
              <span style="opacity:0.5">Group:</span>
              {{member_grp_data.grp_name}}
            </v-chip>
            <v-chip class="ma-2">
              <span style="opacity:0.5">Code:</span>
              {{member_grp_data.grp_code}}
            </v-chip>
            <v-chip class="ma-2">
              <span style="opacity:0.5">Members:</span>
              {{member_grp_data.grp_members}}
            </v-chip>
            <span v-if="member_grp_data.grp_description">
              <br />
              Description: {{member_grp_data.grp_description}}
            </span>
            <br><br>
            <span><v-btn :loading="fetch_loader" color="info" @click="fetch_users()">Fetch Instructors</v-btn></span>
            <span><v-btn :loading="fetch_loader" color="info" @click="fetch_learners()">Fetch Learners</v-btn></span>

            <!-- {{user_list}} -->
          </center>
          <v-row justify="center">
            <v-col cols="12" md="4" sm="4">
              <v-autocomplete v-model="mem_inst" :items="inst_list" item-text="user_name" return-object outlined dense
                chips small-chips label="Employee" persistent-hint hint="Add Employee(s) to group" clearable
                multiple></v-autocomplete>
            </v-col>
            <v-col cols="12" md="4" sm="4">
              <v-autocomplete v-model="mem_stud" :items="stud_list" item-text="user_name" return-object outlined dense
                chips small-chips label="Student" persistent-hint hint="Add Student(s) to group" clearable
                multiple></v-autocomplete>
            </v-col>
          </v-row>
          <v-row justify="center">
            <v-btn :loading="add_member_btn_load" @click="addMembers" color="info">Add To
              Group:{{member_grp_data.grp_name}}</v-btn>
          </v-row>
          <br />
          <v-card>
            <v-card-title>
              Communication Group Members in {{member_grp_data.grp_name}}
              <v-spacer></v-spacer>
              <v-text-field v-model="mem_search" append-icon="mdi-magnify" label="Search" single-line
                hide-details></v-text-field>
            </v-card-title>
            <v-card-text>
              <v-data-table :headers="member_grp_headers" :items="members" :search="mem_search" multi-sort
                class="elevation-1">
                <template v-slot:[`item.mem_active`]="{ item }">
                  <v-switch v-model="item.mem_active" :loading="toggle_member_btn_load"
                    @change="toggleMemberGroup(item)"></v-switch>
                </template>
              </v-data-table>
              <!-- {{members}} -->
            </v-card-text>
          </v-card>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import axios from "axios";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
  components: {
    Breadcrumbs,
  },
  data: () => ({
    snackbar_msg: "",
    // extraBreadcrumbItems: [


    // ],
    // breadcrumbClass: "breadcrumb-style1",
    snackbar: false,
    color: "",
    dialog: false,
    dialog_member: false,
    //
    edit_btn_load: false,
    create_btn_load: false,
    toggle_btn_load: false,
    members_list_load: false,
    toggle_member_btn_load:false,
    add_member_btn_load:false,
    //
    group_name: null,
    group_description: null,
    group_code: null,
    commn_grp_list: null,
    edit_commn_grp: {},
    commn_grp_list_headers: [
      { text: "Name", value: "grp_name" },
      { text: "Code", value: "grp_code" },
      { text: "Description", value: "grp_description" },
      { text: "Members", value: "grp_members" },
      { text: "Created-on", value: "grp_creation_date" },
      { text: "Created-by", value: "grp_icreatedby", align: "center" },
      { text: "Status", value: "grp_isactive", align: "center" },
      { text: "Edit", value: "action", align: "center" }
    ],
    search: "",
    //
    members: null,
    member_grp_data: null,
    member_grp_headers: [
      { text: "Sr. No", value: "srno" },
      { text: "Name", value: "mem_name" },
      { text: "PRN", value: "prn" },
      { text: "Standard", value: "std" },
      { text: "Division", value: "div" },
      { text: "Email", value: "mem_email" },
      { text: "Contact", value: "mem_mob" },
      { text: "Type", value: "mem_type" },
      { text: "Join Date", value: "mem_join_date" },
      { text: "Active", value: "mem_active" }
    ],
    mem_search: "",
    user_list:null,
    inst_list:null,
    stud_list:null,
    mem_inst:[],
    mem_stud:[],
    fetch_loader:false,
  }),
  methods: {
    fetch_learners(){
      this.fetch_loader=true
       axios
        .post("/communicationGroup/fetch_learners")
        .then(res => {
         // this.inst_list = res.data.inst_list
          this.stud_list = res.data.stud_list
          this.showSnackbar("#4CAF50", "Success!!!");
          this.fetch_loader=false
        })
        .catch(error => {
          this.showSnackbar("#b71c1c", "Something went wrong!!!");
        })
        .finally(() => {
          this.fetch_loader = false;
        });
    },
    fetch_users(){
      this.fetch_loader=true
       axios
        .post("/communicationGroup/fetch_users")
        .then(res => {
          this.inst_list = res.data.inst_list
         // this.stud_list = res.data.stud_list
          this.showSnackbar("#4CAF50", "Success!!!");
          this.fetch_loader=false
        })
        .catch(error => {
          this.showSnackbar("#b71c1c", "Something went wrong!!!");
        })
        .finally(() => {
          this.fetch_loader = false;
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    toggleMemberGroup(item){
        this.toggle_member_btn_load = true;
      axios
        .post("/communicationGroup/toggleMemberGroup", item)
        .then(res => {
          this.showSnackbar("#4CAF50", "Action completed!!!");
        })
        .catch(error => {
          this.showSnackbar("#b71c1c", "Something went wrong!!!");
        })
        .finally(() => {
          this.toggle_member_btn_load = false;
        });
    },
    addMembers(){
        if(this.mem_inst.length==0 && this.mem_stud.length==0){
            this.showSnackbar("#b71c1c", "Please select atleast on employee or student!!!");
            return
        }
        const formData={
            stud_list:this.mem_stud,
            inst_list:this.mem_inst,
            grp:this.member_grp_data,
        }
        this.add_member_btn_load = true
        axios
        .post("/communicationGroup/addMembers", formData)
        .then(res => {
          this.members = res.data.members;
          this.commn_grp_list = res.data.commn_grp_list;
          this.mem_stud=[]
          this.mem_inst=[]
          this.showSnackbar("#4CAF50", "Added succesfully!!!");
        })
        .catch(error => {
          this.showSnackbar("#b71c1c", "Something went wrong!!!");
        })
        .finally(() => {
          this.add_member_btn_load = false
        });
    },
    toggleGroup(item) {
      this.toggle_btn_load = true;
      axios
        .post("/communicationGroup/toggleGroup", item)
        .then(res => {
          this.showSnackbar("#4CAF50", "Group status changed!!!");
        })
        .catch(error => {
          this.showSnackbar("#b71c1c", "Something went wrong!!!");
        })
        .finally(() => {
          this.toggle_btn_load = false;
        });
    },
    getMembers(item) {
      this.members_list_load = true;
      this.member_grp_data = item;
      axios
        .post("/communicationGroup/getMembers", item)
        .then(res => {
          this.members = res.data.members;
         
        })
        .catch(error => {})
        .finally(() => {
          this.members_list_load = false;
          this.dialog_member = true;
        });
    },
    saveEditGroup() {
      if (
        this.edit_commn_grp.grp_name == null ||
        this.edit_commn_grp.grp_name == ""
      ) {
        this.showSnackbar("#b71c1c", "Please add group name!!!");
        return;
      }
      this.edit_btn_load = true;
      axios
        .post("/communicationGroup/saveEditGroup", this.edit_commn_grp)
        .then(res => {
          this.commn_grp_list = res.data.commn_grp_list;
          this.showSnackbar("#4CAF50", "Edited Succesfully!!!");
        })
        .catch(error => {
          this.showSnackbar("#b71c1c", "Something went wrong!!!");
        })
        .finally(() => {
          this.edit_btn_load = false;
          this.dialog = false;
        });
    },
    editGroup(item) {
      Object.assign(this.edit_commn_grp, item);
      this.dialog = true;
    },

    createGroup() {
      if (this.group_name == null || this.group_name == "") {
        this.showSnackbar("#b71c1c", "Please add group name!!!");
        return;
      }
      this.create_btn_load = true;
      const formData = {
        grp_name: this.group_name,
        grp_desc: this.group_description
      };
      axios
        .post("/communicationGroup/createGroup", formData)
        .then(res => {
          console.log(res.data);
          if (res.data.status == "YES") {
            this.commn_grp_list = res.data.commn_grp_list;
            this.group_code = res.data.group_code;
            this.showSnackbar(
              "#4CAF50",
              "Group created. Group Code is " + this.group_code
            );
          } else {
            this.showSnackbar("#b71c1c", res.data.status);
          }
        })
        .catch(error => {
          this.showSnackbar("#b71c1c", "Something went wrong!!!");
        })
        .finally(() => {
          this.create_btn_load = false;
        });
    }
  },
  mounted() {
    axios
      .post("/communicationGroup/communicationGroup")
      .then(res => {
        this.commn_grp_list = res.data.commn_grp_list;
      })
      .catch(error => {})
      .finally(() => {});
  }
};
</script>